"use client"

import { Head } from "@inertiajs/react"
import { useState } from "react"

import { DestinationForm } from "@/components/admin/onwards/destination-form"
import { Select } from "@/components/ui/select"
import { DashboardLayout } from "@/layouts/dashboard-layout"

interface Props {
  kinds: string[]
  statuses: string[]
}

const KIND_LABELS: Record<string, string> = {
  resource_link: "Resource link (a plain link, no gate or hours)",
  online_service: "Online service (a deep link, can be gated or need consent)",
  helpline: "Helpline (phone and webchat, can be time-limited)",
}

export default function NewDestination({ kinds, statuses }: Props) {
  const [kind, setKind] = useState<string | null>(null)

  return (
    <DashboardLayout>
      <Head title="New destination" />
      <main className="mx-auto flex w-full max-w-2xl flex-col gap-8 px-4 pt-8 pb-12 lg:px-8">
        <header className="flex flex-col gap-0.5">
          <h1 className="text-primary font-display md:text-display-xs text-xl font-semibold">
            New onward destination
          </h1>
          <p className="text-md text-tertiary">
            Add a support service to the catalogue. It stays a draft until you
            validate it.
          </p>
        </header>

        <Select
          label="Kind"
          placeholder="Choose a destination kind"
          selectedKey={kind}
          onChange={(key) => key != null && setKind(String(key))}
          items={kinds.map((k) => ({ id: k, label: KIND_LABELS[k] ?? k }))}
        >
          {(item) => (
            <Select.Item key={item.id} id={item.id}>
              {item.label}
            </Select.Item>
          )}
        </Select>

        {kind && <DestinationForm mode="new" kind={kind} statuses={statuses} />}
      </main>
    </DashboardLayout>
  )
}
